/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Formik } from 'formik';
import { FC, useRef, useState } from 'react';
import * as yup from 'yup';
import { useFormContext } from '../../../../../contexts/FormContext';
import {
  FormatChangerInput,
  FormType,
  PersonaMarketingIdeasInput,
} from '../../../../../types/FormTypes';
import { ListenToFormikValues } from '../../../../shared/formik/ListenToFormikValues';
import { GenerateResponseButtons } from '../GenerateResponseButtons';
import formStyles from '../formStyles.module.css';
import { usePersonaContext } from '../../../../../contexts/PersonaContext';
import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import styles from './changerStyle.module.css';
import { AudiencePersonaSoloPopup } from '../../../personasPage/AudiencePersonaPopup';
import { BasicPopup2 } from '../../../../shared/popups/BasicPopup';
import { BasicButton } from '../../../../shared/buttons/BasicButton';
import { EditAudiencePersonaPopup } from '../../../personasPage/EditAudiencePersonaPopup';
import { BoxedAutoResizeTextarea } from '../../../../shared/inputs/BoxedAutoResizeTextarea';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import { AudiencePersona, ProductPersona } from '../../../../../types/Persona.type';

const DropDownContainer3 = styled('div')`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  z-index: 2;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownIcon3 = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 2;
  flex-direction: column;
`;

const DropDownHeader = styled('div')`
  width: 100%;
  cursor: pointer;
  margin-bottom: 0.4em;
  padding: 0.5em 0.5em 0.5em 0.5em;
  font-weight: 400;
  font-size: 1rem;
  color: black;
  font-family: "Poppins", sans-serif;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  display: flex;
`;

const DropDownListContainer = styled('div')`
  width: 100%;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.3rem;
  font-family: "Poppins", sans-serif;
  color: #3faffa;
  background: white;
  border: 1.83px solid black;
  border-radius: 2px;
  width: 100%;
  z-index: 0;
  max-height: 41vh;
`;

const DropDownList = styled('ul')`
  width: 100%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  z-index: 0;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 2px;
  color: black;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  max-height: 40vh;
  overflow: scroll;
  overflow-x: hidden;
  &:first-of-type {
    padding-top: 0em;
  }
`;

const ListItem = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.6em;
  padding-top: 0.6em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  font-family: "Poppins", sans-serif;
  display: flex;
  z-index: 500;

  justify-content: space-between;
  align-items: center;
  &: last-of-type {
    border-bottom: 0px;
  }

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const ListItem2 = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.8em;
  padding-top: 0.8em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  color: gray;
  display: flex;
  font-family: "Poppins", sans-serif;
  align-items: center;

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const Innertext2 = styled('div')`
  padding-top: 0.5em;
  padding-left: 0.5em;
  padding-bottom: 0.5em;
`;

const PersonaMarketingIdeasInputsSchema = yup.object<
  Partial<Record<keyof FormatChangerInput, yup.AnySchema>>
>({
  text: yup.string().required('Please enter the text to convert.'),
  format: yup.string().required('Please type a format to change to.'),
  //   companyName: yup.string().required("Please add your company's name"),
  //   companyWebsite: yup.string().notRequired(),
  //   intent: yup.string().required('Please select the goal of your marketing campaign.'),
  // topic: yup.string().required('Please add the brainstorming topic'),
  //   brandDescription: yup.string().required(),
  //     industry: yup.string().required(),
  //     painpoint: yup.string().required(),
  //     location: yup.string().required(),
  //     occupation: yup.string().required(),
  //   age: yup.string().required(),
});

export const FormatChangerForm: FC = () => {
  const {
    formatChangerInput,
    setFormatChangerInput,
    setCanKeepGoing,
    loading,
    submitToolkitForm,
  } = useFormContext();
  const { audiencePersonas, currentAudPersona, saveCurrentPersonas } = usePersonaContext();
  const { deleteAudience } = usePersonaContext();
  const { userData } = useAuthContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [selectedAudOption, setSelectedAudOption] = useState(
    currentAudPersona?.audience ?? 'Please Select an Audience'
  );
  const [selectedAudience, setAudienceList] = useState('');
  const menuRef = useRef<HTMLDivElement>(null);
  const menuRef2 = useRef<HTMLDivElement>(null);
  const menuRef3 = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handler = (e: { target: any }) => {
      if (!menuRef3.current?.contains(e.target)) {
        setIsOpen3(false);
      }
      if (!menuRef2.current?.contains(e.target)) {
        setIsOpen2(false);
      }
      if (!menuRef.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });
  const toggling2 = () => setIsOpen2(!isOpen2);
  const [showAudiencePopup, setShowAudiencePopup] = useState(false);
  const [showAudEditPopup, setAudEditPopup] = useState(false);
  const [showAudDeletePopup, setAudDeletePopup] = useState(false);

  const [A0, setA0] = useState(currentAudPersona?.audience ?? ''); //audience
  const [A1, setA1] = useState(currentAudPersona?.painpoints ?? ''); //painpoint
  const [A2, setA2] = useState(currentAudPersona?.location ?? ['']); //location
  const [A3, setA3] = useState(currentAudPersona?.occupation ?? ['']); //occupation
  const [A4, setA4] = useState(currentAudPersona?.age ?? ['']); //age
  const [A5, setA5] = useState(currentAudPersona?.goals ?? ''); //goals
  const [A6, setA6] = useState(currentAudPersona?.barriers ?? ''); //barriers
  const [A7, setA7] = useState(currentAudPersona?.triggers ?? ''); //triggers
  const [A8, setA8] = useState(currentAudPersona?.profilePic ?? ''); //ProfilePic
  const [picture2, setPicture2] = useState(currentAudPersona?.profilePic ?? '');

  const [a1, seta1] = useState('');
  const [a2, seta2] = useState({ value: '', label: '' });
  const [a3, seta3] = useState(['']);
  const [a4, seta4] = useState(['']);
  const [a5, seta5] = useState(['']);
  const [a6, seta6] = useState(['']);
  const [a7, seta7] = useState('');
  const [a8, seta8] = useState('');
  const [a9, seta9] = useState('');
  const [a10, seta10] = useState('');
  const [a11, seta11] = useState('');
  const [a12, seta12] = useState('');
  const [audError, setAudError] = useState(false);

  const onAudOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>,
      value3: React.SetStateAction<string[]>,
      value4: React.SetStateAction<string[]>,
      value5: React.SetStateAction<string[]>,
      value6: React.SetStateAction<string>,
      value7: React.SetStateAction<string>,
      value8: React.SetStateAction<string>,
      v9: React.SetStateAction<string>,
      entireAud: React.SetStateAction<AudiencePersona>
    ) =>
    () => {
      setSelectedAudOption(value);
      setA0(value);
      setA1(value2);
      setA2(value3);
      setA3(value4);
      setA4(value5);
      setA5(value6);
      setA6(value7);
      setA7(value8);
      setA8(v9);
      saveCurrentPersonas(
                {} as ProductPersona,
                entireAud as AudiencePersona,
              );
      setPicture2(v9);
      setAudError(false);
      setIsOpen2(false);
    };

  const AudienceEditClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>
    ) =>
    () => {
      seta1(a1); //audience
      seta2(a2); // brand
      seta3(a3); //gender
      seta4(a4); //age
      seta5(a5); //occupation
      seta6(a6); //location
      seta7(a7); //painpoint
      seta8(a8); //id
      toggling2;
      setAudEditPopup(true);
    };

  const AudienceDeleteClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>
    ) =>
    () => {
      seta1(a1); //audience
      seta2(a2); // brand
      seta3(a3); //gender
      seta4(a4); //age
      seta5(a5); //occupation
      seta6(a6); //location
      seta7(a7); //painpoint
      seta8(a8); //id
      toggling2;
      setAudDeletePopup(true);
    };

  const closeAudience = () => {
    // Handle the close event here
    setShowAudiencePopup(false);
  };

  const closeEditAudience = () => {
    setAudEditPopup(false);
  };

  // Inputs may need to be prefilled
  //   if (!personaMarketingIdeasInput) return null;

  return (
    <Formik
      initialValues={formatChangerInput}
      onSubmit={async (values, actions) => {
        await submitToolkitForm({
          values,
          actions,
          formType: FormType.FORMAT_CHANGER,
        });
      }}
      validationSchema={PersonaMarketingIdeasInputsSchema}
    >
      {(props) => (
        <>
          <div className={formStyles['form-container']}>
            <ListenToFormikValues
              callBackFunc={(values) => {
                setFormatChangerInput(values as FormatChangerInput);
                setCanKeepGoing(false);
              }}
            />

            <div>
              <div className={styles['create-button3']}>
                <div></div>
              </div>
            </div>
            <div>
              <div>
                <h2>What text do you want to change?</h2>
              </div>

              <BoxedAutoResizeTextarea
                id="textarea"
                placeholder="Please enter the text you want to change."
                value={props.values.text}
                setValue={props.handleChange('text')}
                disabled={loading}
                errors={props.errors.text as string}
                touched={props.touched.text ? true : false}
                onBlur={props.handleBlur}
              />
            </div>

            <div>
              <div className={styles['create-button']}>
                <div>
                  <h2 id="aud">
                    What Format would you like to change this to?
                  </h2>
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Blog, bulletin, summary, etc..."
                    name="format"
                    value={props.values.format}
                    onChange={props.handleChange('format')}
                    className={styles['option-list']}
                  />
                </div>
              </div>
            </div>
          </div>

          <GenerateResponseButtons
            onSubmit={() => {
              props.handleSubmit();
            }}
          />
        </>
      )}
    </Formik>
  );
};
